// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ArrowDownIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 30 19" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M3.6533e-06 3.69232C-1.62746e-07 2.96204 0.219884 2.24818 0.631946 1.64098C1.04401 1.03378 1.62979 0.560507 2.31503 0.28105C3.00026 0.00159205 3.75419 -0.0715245 4.48162 0.0709583C5.20906 0.213441 5.87727 0.565131 6.40171 1.08153L15 9.5475L23.5983 1.08153C24.3015 0.389071 25.2553 4.88391e-05 26.2499 2.72438e-05C27.2445 5.64854e-06 28.1983 0.388989 28.9016 1.08142C29.6049 1.77384 30 2.713 30 3.69226C30 4.67153 29.605 5.61066 28.9017 6.30311L17.6517 17.38C17.3035 17.7229 16.8901 17.9948 16.4351 18.1804C15.9801 18.366 15.4925 18.4615 15 18.4615C14.5075 18.4615 14.0199 18.366 13.5649 18.1804C13.1099 17.9948 12.6965 17.7229 12.3483 17.38L1.09829 6.30311C0.749541 5.96065 0.472985 5.55372 0.284504 5.10566C0.0960219 4.65761 -0.000677155 4.17728 3.6533e-06 3.69232V3.69232Z" />
        </svg>
      )
    }
  </Icon>
);

export default ArrowDownIcon;
